<template>
  <!-- select 2 demo -->
  <div v-visible-track="'Iframe.ancientDnaAncientOriginsBreakdownTailorTheModelClicked'">
    <b-modal
      ref="select-region-modal"
      hide-footer
      hide-header
      @hidden="hiddenModal"
      size="lg"
    >
     <div class="model-close-container">
      <button class="close-modal-btn" @click="hiddenModal()"><CloseModalIcon /></button>
     </div>

     <div class="select-region-modal-body info-modal-container cs-scroll-style" :style="{ 'height': $store.state.appConfig.bodyHeight + 'px' }">
        <div>
          <div class="info-modal-header">
            <h5>{{ $tI_G('Ethnicity selector Title') }}</h5>
          </div>
          <p class="description">
            {{ $tI_YO_G('Ethnicity selector Body') }}
          </p>
        </div>
        <div class="dropdown-container" ref="dropdownContainer">
          <label for="custom-dropdown" class="dropdown-label">{{ $tI_YO_G('Ethnicity selector Dropdown title') }}</label>
          <div class="select-custom-dropdown">
            <div class="dropdown-select" @click="toggleDropdown">{{ $t(selectedRegionName) || $t('Global') }}</div>
            <div class="custom-dropdown-menu cs-scroll-style" v-if="isDropdownOpen">
              <div 
                v-for="(item, index) in regionDatas" 
                :key="index" 
                class="custom-dropdown-item" 
                @click="toggleSubItems(index)"
              >
                {{ $t(item.groupName) }}
                <div v-if="item.regionList && item.isOpen" class="subitem-container">
                  <div 
                    v-for="(subItem, subIndex) in item.regionList" 
                    :key="subIndex" 
                    class="subitem"
                    @click.stop="selectRegion(subItem)"
                  >
                    {{ $t(subItem.regionName) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
     </div>

     <div class="model-info-bottom select-region-bottom">
      <div></div>
      <button class="info-modal-btn single-btn" 
        v-click-track="'Iframe.ancientDnaAncientOriginsBreakdownTailorTheModelChange'"
        @click="applySelectedRegion()">
        {{ $tI_G('Ethnicity selector apply CTA') }}
      </button>
     </div>
    </b-modal>
  </div>
</template>

<script>
import communicationService from '@/services/PostMessageCommunation/CommunicationService';
import dataKeys from '@/services/PostMessageCommunation/enums/DataKeys';

import CloseModalIcon from '@/components/icons/CloseModalIcon.vue';
export default {
  components: {
    CloseModalIcon,
  },
  props: {
    modalObject: {
      type: Object,
    },
    callback: {
      type: Function,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      isDropdownOpen: false,
      selectedRegion: null,

      regionDatas: [],
    }
  },
  methods: {
    initialModal() {
      communicationService.sendTriggerToParent({ key: dataKeys.MODAL_STATUS, value: true });
      this.$refs['select-region-modal'].show();
    },
    hiddenModal() {
      /* eslint-disable */
      this.modalObject.showModal = false;
      this.$refs['select-region-modal'].hide();
      communicationService.sendTriggerToParent({ key: dataKeys.MODAL_STATUS, value: false });
    },
    applySelectedRegion() {
      this.$store.commit('region/setSelectRegion', this.selectedRegion);
      this.hiddenModal();
      
      communicationService.sendDataToParent({ 
        key: dataKeys.SAVE_DEFAULT_ETHNICITY, 
        value: this.selectedRegion.guid,
      });
    },

    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    toggleSubItems(index) {
      if (this.regionDatas[index].regionList) {
        this.$set(this.regionDatas[index], 'isOpen', !this.regionDatas[index].isOpen);
      } else {
        this.selectRegion(this.regionDatas[index].groupName);
        this.isDropdownOpen = false;
      }
    },
    selectRegion(region) {
      this.selectedRegion = region;
      this.isDropdownOpen = false;
    },

    closeDropdown(event) {
      if (!this.$refs.dropdownContainer.contains(event.target)) {
        this.isDropdownOpen = false;
      }
    },
  },
  computed: {
    selectedRegionName() {
      return this.selectedRegion ? this.selectedRegion.regionName : '';
    },
  },
  mounted() {
    this.initialModal();
    this.selectedRegion = this.$store.getters['region/getSelectedRegion'];
    this.$store.dispatch('region/fetchRegionDatas').then(x => {
      this.regionDatas = this.$store.getters['region/getRegionDatas'];
    });

    document.addEventListener('click', this.closeDropdown);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeDropdown);
  },
};
</script>

<style lang="scss" scoped>
.select-region-modal-body {
  display: block;
  position: relative;
  max-height: 350px;

  .description {
    font-size: 15px;
  }

  .dropdown-container {
    padding: 1rem 0;

    .select-custom-dropdown {
      width: 400px !important;
    }
  }
}
@media only screen and (max-width: 769px) {
  .select-region-modal-body {
    display: block;
    max-height: 450px;
    .dropdown-container .select-custom-dropdown {
      width: 100% !important;
    }
  }
}
</style>
